import {
  expoPasarelasService
} from '../_services';

const state = {}

const actions = {
  /*  REDSYS */
  addPasarelaRedsys({
    commit,
    dispatch
  }, datos) {

    return new Promise((resolve, reject) => {
      expoPasarelasService.addPasarelaRedsys(datos)
        .then(
          data => {
            dispatch('expos/getOneById', {
              id: datos.expo_id,
              silent: true
            }, {
              root: true
            });
            dispatch('alert/success', 'Registro Creado correctamente', {
              root: true
            })
            return resolve(true);
          },
          error => {
            dispatch('alert/error', {
              text: 'Se ha producido un error al crear el registro',
              data: error
            }, {
              root: true
            })
          }
        );
    });
  },


  editPasarelaRedsys({
    dispatch
  }, datos) {
    return new Promise((resolve, reject) => {

      expoPasarelasService.editPasarelaRedsys(datos)
        .then(
          data => {
            dispatch('expos/getOneById', {
              id: datos.expo_id,
              silent: true
            }, {
              root: true
            });
            dispatch('alert/success', 'Pasarela actualizada correctamente', {
              root: true
            })
            return resolve(true);
          },
          error => {
            dispatch('alert/error', {
              text: 'Se ha producido un error al actualizar el registro',
              data: error
            }, {
              root: true
            })
          }
        );
    });
  },

  /* PAYPAL */
  addPasarelaPaypal({
    commit,
    dispatch
  }, datos) {

    return new Promise((resolve, reject) => {
      expoPasarelasService.addPasarelaPaypal(datos)
        .then(
          data => {
            dispatch('expos/getOneById', {
              id: datos.expo_id,
              silent: true
            }, {
              root: true
            });
            dispatch('alert/success', 'Registro Creado correctamente', {
              root: true
            })
            return resolve(true);
          },
          error => {
            dispatch('alert/error', {
              text: 'Se ha producido un error al crear el registro',
              data: error
            }, {
              root: true
            })
          }
        );
    });
  },


  editPasarelaPaypal({
    dispatch
  }, datos) {
    return new Promise((resolve, reject) => {

      expoPasarelasService.editPasarelaPaypal(datos)
        .then(
          data => {
            dispatch('expos/getOneById', {
              id: datos.expo_id,
              silent: true
            }, {
              root: true
            });
            dispatch('alert/success', 'Registro actualizado correctamente', {
              root: true
            })
            return resolve(true);
          },
          error => {
            dispatch('alert/error', {
              text: 'Se ha producido un error al actualizar el registro',
              data: error
            }, {
              root: true
            })
          }
        );
    });
  },

  /* TRANSFERENCIA */
  addPasarelaTransfer({
    commit,
    dispatch
  }, datos) {

    return new Promise((resolve, reject) => {
      expoPasarelasService.addPasarelaTransfer(datos)
        .then(
          data => {
            dispatch('expos/getOneById', {
              id: datos.expo_id,
              silent: true
            }, {
              root: true
            });
            dispatch('alert/success', 'Registro Creado correctamente', {
              root: true
            })
            return resolve(true);
          },
          error => {
            dispatch('alert/error', {
              text: 'Se ha producido un error al crear el registro',
              data: error
            }, {
              root: true
            })
          }
        );
    });
  },


  editPasarelaTransfer({
    dispatch
  }, datos) {
    return new Promise((resolve, reject) => {

      expoPasarelasService.editPasarelaTransfer(datos)
        .then(
          data => {
            dispatch('expos/getOneById', {
              id: datos.expo_id,
              silent: true
            }, {
              root: true
            });
            dispatch('alert/success', 'Registro actualizado correctamente', {
              root: true
            })
            return resolve(true);
          },
          error => {
            dispatch('alert/error', {
              text: 'Se ha producido un error al actualizar el registro',
              data: error
            }, {
              root: true
            })
          }
        );
    });
  }
}




const mutations = {

}

const getters = {

}

export const expoPasarelas = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
